export const localValidate = (formState) => {
  let errors = {};

  if (formState.name.trim().length === 0) {
    errors.personId = 'A Coach Name is required';
  }

  return errors;
};

const AthleteRaceStatsValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default AthleteRaceStatsValidation;